import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FooterComponent } from "./component/footer/footer.component";
import { NavbarComponent } from "./component/navbar/navbar.component";
import { RouterModule } from "@angular/router";
import { ToasterComponent } from "./component/toast-notification/toaster.component";
import { SubmitButtonComponent } from "./component/submit-button/submit-button.component";
import { BootstrapModule } from "./modules/bootstrap-module";
import { NgTemplateNameDirective } from "./directive/ng-template.directive";
import { LoadingBarComponent } from "./component/loading-bar/loading-bar.component";

@NgModule({
    declarations: [
        NavbarComponent,
        FooterComponent,
        ToasterComponent,
        SubmitButtonComponent,
        NgTemplateNameDirective,
        LoadingBarComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        FlexLayoutModule,
        RouterModule,
        BootstrapModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        FlexLayoutModule,
        RouterModule,
        BootstrapModule,
        NavbarComponent,
        FooterComponent,
        ToasterComponent,
        SubmitButtonComponent,
        NgTemplateNameDirective,
        LoadingBarComponent,
    ],
    providers: [
    ]
})
export class SharedModule { }